import styled from 'styled-components';

export const ModalWrapper = styled.div`
  background: var(--color-surface);
  border-radius: 12px;
  box-shadow: 0 20px 45px var(--color-shadow);
  padding: 28px 32px;
  text-align: left;
  width: min(760px, 90vw);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  color: var(--color-text);
`;
